module.exports = __webpack_public_path__ + "static/modernizace-php-aplikaci-3-0f8400c82f1ca24a85ee140e14754ab6.jpg";